// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-rate-field .yxt-rate{height:unset}.lc-am-rate-field .yxt-rate .yxt-rate__item .yxt-rate__icon{line-height:36px}.lc-am-rate-field .yxt-rate .yxt-rate__item .yxt-rate__icon .yxt-rate__decimal{top:50%;transform:translateY(-50%)}", ""]);
// Exports
module.exports = exports;
